import { Controller } from '@hotwired/stimulus';
import { modalController } from '@ionic/core';

// Controls ionic modal
export default class extends Controller {
  static targets = ['dialogContent', 'dialogTitle'];
  connect() {
    var modal = this.element.querySelector('ion-modal');
    if (!modal) return;
    this.modal = modal;
  }

  openModal(event) {
    this.dialogContentTarget.innerHTML = event.params.text;
    this.dialogTitleTarget.innerHTML = event.params.title;
    this.modal.isOpen = true;
    event.preventDefault();
  }
}
